import React, { useEffect, useState } from "react";
import { Box, Button, FormControl, Grid, MenuItem, Select, TextField, Typography, Tabs, Tab, Dialog, DialogTitle, DialogContent, DialogActions, Container, IconButton, Tooltip } from "@mui/material";
import swal from "sweetalert";
import DefaultLayout from '../../../Components/DefaultLayout';
import Backdrop from '@mui/material/Backdrop';
import Freez from '../../../Components/Loader/Loader'
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { fetchData, postData, postFormData } from "../../../redux/apiSlice";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { DateRangePicker, createStaticRanges } from 'react-date-range';
import { useDateSelectionRange } from "../../../Components/CommonFormula";
import EmailIcon from "@mui/icons-material/Email";
import CloseIcon from '@mui/icons-material/Close';
import { Delete, Visibility } from "@mui/icons-material";

const RecipientList = () => {
    const navigate = useNavigate();
    const [freez, setFreez] = React.useState(false);
    const [rows, setRows] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState("Enrollments");
    const [selectedSubCategory, setSelectedSubCategory] = useState(null);
    const [activeTab, setActiveTab] = useState(0);
    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    const [reportName, setReportName] = useState("");
    const handleOpen = () => {
        setOpen(true);
    };
    const [softwareData, setSoftwareData] = useState([]);
    const [selectedZipCodeRange, setSelectedZipCodeRange] = useState(null);
    const [categoryButtons, setCategoryButtons] = useState({
        Enrollments: ["Total Enrollments", "Active Enrollments", "Top 50", "Top 100"],
        Commission: ["Approved Commission", "Paid Commission"],
        Referrals: ["Active Affiliate Enrolled", "Affiliate Referred Active Enrolled"],
        SoftwareReferral: [],
        zipCode: ["50", "100", "150", "200", "250", "300"],
    });
    useEffect(() => {
        const subcategories = categoryButtons[selectedCategory];
        if (subcategories && subcategories.length > 0) {
            setSelectedSubCategory(subcategories[0]); // Auto-select first
        } else {
            setSelectedSubCategory(""); // Reset if empty
        }
    }, [selectedCategory, categoryButtons]);

    useEffect(() => {
        const fetchSoftwareReferrals = async () => {
            try {
                const res = await dispatch(fetchData("/getSoftwareInfo")).unwrap();
                if (res?.success) {
                    // Store software_name and link_name
                    const softwareList = res.data.map(item => ({
                        name: item.software_name,
                        link: item.link_name,
                    }))
                    //  software names for category buttons
                    setCategoryButtons(prevState => ({
                        ...prevState,
                        SoftwareReferral: ["All", ...softwareList.map(item => item.name)],
                    }));
                    // Store complete software data
                    setSoftwareData(softwareList);
                } else {
                    swal("Error!", "Something went wrong!", "error");
                }
            } catch (error) {
                console.log("Error fetching software referrals:", error);
                swal("Error!", "Failed to fetch software referrals", "error");
            }
        };

        fetchSoftwareReferrals();
    }, [dispatch]);
    const { selectionRange, setSelectionRange, startDate, endDate, clearFilter } = useDateSelectionRange();
    const [savedReports, setSavedReports] = useState([]);
    // const [threshold, setThreshold] = useState(10);
    const [minThreshold, setMinThreshold] = useState("");
    const [maxThreshold, setMaxThreshold] = useState("");
    const [thresholdError, setThresholdError] = useState(false); // To track validation error
    const [showTable, setShowTable] = useState(false);
    const [showSavedReportsTable, setShowSavedReportsTable] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [zipCode, setZipCode] = useState("");
    const handleMinChange = (e) => {
        const value = e.target.value;
        if (value === "" || /^\d*$/.test(value)) {
            setMinThreshold(value);
            if (parseInt(value, 10) > parseInt(maxThreshold, 10)) {      // Check if min > max and show error
                setThresholdError(true);
            } else {
                setThresholdError(false);
            }
        }
    };
    const handleMaxChange = (e) => {
        const value = e.target.value;
        if (value === "" || /^\d*$/.test(value)) {
            setMaxThreshold(value);
            if (parseInt(value, 10) < parseInt(minThreshold, 10)) {  // Check if max < min and show error
                setThresholdError(true);
            } else {
                setThresholdError(false);
            }
        }
    };
    const dataGridColumns = [
        "company_name",
        "first_name",
        "last_name",
        "email",
        "communication_email",
        "phone_no",
        "address",
        "city",
        "state_code",
        "zip_code",
        "active_enrollements",
        "total_enrollements",
        "totalApprovedCommission",
        "paidAmount",
        "marketing_type",
        "referredCompanies"
    ].map(field => ({
        field,
        headerName: field
            .split("_")
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" "),
        width: 200,
        renderCell: (params) => (
            <Box className="datatable">
                {params.value || "N/A"}
            </Box>
        )
    }));

    const [uploadedFile, setUploadedFile] = useState(null);
    const handleFreezStop = () => {
        setFreez(false);
    };
    const handleFreezStart = () => {
        setFreez(true);
    };

    // FOR immediate update IN THE STATE FOR TOP50 AND TOP 100
    useEffect(() => {
        if (selectedSubCategory === "Top 50" || selectedSubCategory === "Top 100") {
            setMinThreshold("");
            setMaxThreshold("");
        } else {
            setMinThreshold(1); // default min threshold
            setMaxThreshold(10); // default max threshold
        }
    }, [selectedSubCategory]);

    const handleFetchCommonFilterData = async () => {
        let token = localStorage.getItem("token");
        if (!token) {
            navigate('/login');
            return;
        }
        if (selectedCategory === "zipCode") {
            if (!zipCode || zipCode.length !== 5) {
                swal("Invalid Input", "Please enter a 5-digit zip code.", "warning");
                return;
            }
        }
        if (selectedCategory !== "zipCode" && selectedSubCategory !== "Top 50" && selectedSubCategory !== "Top 100") {
            if (minThreshold === "" || maxThreshold === "" || isNaN(Number(minThreshold)) || isNaN(Number(maxThreshold))) {
                swal("Invalid Input", "Both Min and Max Threshold are required and must be numbers.", "warning");
                return;
            }
        }
        handleFreezStart();
        const formatDateToLocalISO = (date) => {
            if (!date) return null;
            const localDate = new Date(date);
            return `${localDate.getFullYear()}-${String(localDate.getMonth() + 1).padStart(2, "0")}-${String(localDate.getDate()).padStart(2, "0")}`;
        };
        const validFilters = {
            Enrollments: "enrollement",
            Commission: "commission",
            Referrals: "referral",
            SoftwareReferral: "softwareReferral",
            zipCode: "zipCode"
        };
        const filterMap = {
            Enrollments: {
                "Total Enrollments": "totalEnrollments",
                "Active Enrollments": "activeEnrollments",
                "Top 50": "top50",
                "Top 100": "top100",
            },
            Commission: {
                "Approved Commission": "approvedCommission",
                "Paid Commission": "paidCommission",
                // "Bonus Commission": "bonusCommission",
                // "Target Incentives": "targetIncentives",
            },
            Referrals: {
                "Active Affiliate Enrolled": "referralsActiveEnrolled",
                "Affiliate Referred Active Enrolled": "affiliateReferredActiveEnrolled",
            }
        };
        let filterValue = validFilters[selectedCategory] || "enrollement";
        const subCategoryValue = filterMap[selectedCategory]?.[selectedSubCategory] || "";

        let memberAccountStatus = null;
        if (selectedSubCategory === "Active Enrollments") {
            memberAccountStatus = "ACTIVE";
        }
        let topCompanyValue = null;
        if (selectedSubCategory === "Top 50") {
            topCompanyValue = '50';
        } else if (selectedSubCategory === "Top 100") {
            topCompanyValue = '100';
        }
        let ParentMemberActive = null
        if (selectedSubCategory === "Active Affiliate Enrolled") {
            ParentMemberActive = '5';
        }
        let ChildMemberActive = null
        if (selectedSubCategory === "Affiliate Referred Active Enrolled") {
            ChildMemberActive = '5';
        }
        if (selectedCategory === "Commission") {
            filterValue = selectedSubCategory === "Paid Commission" ? "paidCommission" : "approvedCommission";
        }
        const selectedSoftware = softwareData.find(item => item.name === selectedSubCategory);
        const args = {
            filter: filterValue,
            subCategory: subCategoryValue,
            fromDate: formatDateToLocalISO(startDate),
            toDate: formatDateToLocalISO(endDate),
            minThreshold: minThreshold,
            maxThreshold: maxThreshold,
            memberAccountStatus: memberAccountStatus,
            applyDate: true,
            // softwareType: "all",
            topCompany: topCompanyValue,
            ChildMemberActive: ChildMemberActive,
            ParentMemberActive: ParentMemberActive,
            zipCode: selectedCategory === "zipCode" && zipCode ? Number(zipCode) : null,
            range: selectedCategory === "zipCode" ? Number(selectedZipCodeRange) || 10 : null,
            softwareType: selectedCategory === "SoftwareReferral"
                ? (selectedSoftware?.link ? [selectedSoftware.link] : "all")  // Array if link exists, else string
                : ["all"],  // Default case       
            // link_name: selectedCategory === "SoftwareReferral" ? (selectedSoftware ? selectedSoftware.link : null) : null,
        };
        console.log("Sending Request Body:", args);
        const apiUrl = "/commonFilterData";
        try {
            const res = await dispatch(postData({ apiUrl, args })).unwrap();
            if (res?.success) {
                const formattedRows = res.data.map((item, index) => ({
                    id: index + 1,
                    ...item,
                }));
                setRows(formattedRows);
                setShowTable(true);
            } else {
                swal("Error!", "Something went wrong!", "error");
            }
        } catch (error) {
            console.log("Error fetching data:", error);
            swal("Error!", "Failed to fetch data", "error");
        } finally {
            handleFreezStop();
        }
    };
    // Common function to generate CSV file
    const generateTableCSV = (columns, rows, fileName = "RecipientList") => {
        if (rows.length === 0) {
            swal("No Data", "There is no data to generate CSV!", "warning");
            return null;
        }
        const formatCSVValue = (value) => {
            if (value === null || value === undefined) return "";
            const trimmed = typeof value === "string" ? value.trim() : value;
            const stringValue = String(trimmed);
            const escaped = stringValue.replace(/"/g, '""'); // escape quotes
            return /[",\n]/.test(escaped) ? `"${escaped}"` : escaped; // wrap if special chars
        };
        const headers = columns.map(col => formatCSVValue(col.headerName || col.field)).join(",");
        const csvRows = rows.map(row =>
            columns.map(col => formatCSVValue(row[col.field] || "")).join(",")
        );
        const csvContent = [headers, ...csvRows].join("\n");
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        return new File([blob], `${fileName}_${Date.now()}.csv`, { type: "text/csv" });
    };
    const handleDownloadCSV = () => {
        const csvFile = generateTableCSV(dataGridColumns, rows, "RecipientList");
        if (!csvFile) return;
        const url = URL.createObjectURL(csvFile);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", csvFile.name);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    }
    const handleSaveReport = async () => {
        if (!reportName) {
            swal("Error!", "Report name cannot be empty.", "error");
            return;
        }
        const token = localStorage.getItem("token");
        if (!token) {
            navigate('/login');
            return;
        }
        try {
            // Fetch saved reports 
            handleFreezStart();
            const apiUrl = "/reports/all";
            const res = await dispatch(fetchData(apiUrl)).unwrap();
            if (res?.success) {
                const savedReports = res.data
                    .map(item => item.report_name ? item.report_name.toLowerCase() : "") // Handle null values
                    .filter(name => name); // Remove empty strings from the list
                // Check for duplicate report name
                if (savedReports.includes(reportName.toLowerCase())) {
                    swal("Error!", "A report with this name already exists. Choose a different name.", "error");
                    return;
                }
            } else {
                swal("Error!", "Failed to fetch reports for duplicate check.", "error");
                return;
            }
            const saveUrl = "/reports/save";
            const dataToSave = selectedRows.length > 0 ? selectedRows : rows;
            const csvFile = generateTableCSV(dataGridColumns, dataToSave, "report");
            if (!csvFile) return;
            const formData = new FormData();
            formData.append("reportName", reportName);
            formData.append("fromDate", new Date(startDate).toISOString());
            formData.append("toDate", new Date(endDate).toISOString());
            formData.append("file", csvFile);
            formData.append("minThreshold", minThreshold ?? "");
            formData.append("maxThreshold", maxThreshold ?? "");
            const saveRes = await dispatch(postFormData({ apiUrl: saveUrl, formData })).unwrap();
            if (saveRes?.success) {
                swal("Success!", "Report saved successfully!", "success");
                setRows([]); //TO CLEAR TABLE AFTER SAVE REPORT
                setOpen(false);
                setActiveTab(1);
            } else {
                swal("Error!", saveRes.message || "Failed to save report", "error");
            }
        } catch (error) {
            console.log("Error saving report:", error);
            swal("Error!", "Something went wrong while saving the report", "error");
        } finally {
            handleFreezStop();
        }
    };

    // Common function to generate sample CSV file
    const generateCSVFile = () => {
        const csvData = [
            ["Company Name", "Name", "Email", "Phone no."],
            ["Tech Solutions", "Jushawn Steadman", "test1@yopmail.com", "3213177781"],
            ["Finance Corp", "Mark St Croix", "test2@yopmail.com", "8889552409"],
            ["BuildRight LLC", "Alex Santillanes", "test3@yopmail.com", "7024034637"],
        ];
        const csvContent = csvData.map((row) => row.join(",")).join("\n");
        const blob = new Blob([csvContent], { type: "text/csv" });

        let timestamp = new Date().getTime();
        return new File([blob], `sample_${timestamp}.csv`, { type: "text/csv" });
    };
    //  function for downloading
    const handleDownloadSampleCSV = () => {
        const csvFile = generateCSVFile();
        const url = URL.createObjectURL(csvFile);
        const a = document.createElement("a");
        a.href = url;
        a.download = csvFile.name;
        a.click();
        URL.revokeObjectURL(url);
    };
    // TO SHOW THE CSV IN THE TABLE AFTER UPLOAD
    const [csvDialogOpen, setCsvDialogOpen] = useState(false);
    const [csvData, setCsvData] = useState([]);
    const [csvColumns, setCsvColumns] = useState([]);
    const handleCSVUpload = (event) => {
        let token = localStorage.getItem("token");
        if (!token) {
            navigate('/login');
            return;
        }
        const file = event.target.files[0];
        if (!file) return;
        setUploadedFile(file);
        handleFreezStart();
        const generateRandomString = (length) => {
            const characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
            let result = '';
            for (let i = 0; i < length; i++) {
                result += characters.charAt(Math.floor(Math.random() * characters.length));
            }
            return result;
        };
        const originalName = file.name.split('.').slice(0, -1).join('.');
        const extension = file.name.split('.').pop();
        const uniqueSuffix = generateRandomString(4);
        const uniqueReportName = `${originalName}_${uniqueSuffix}.${extension}`;
        const formData = new FormData();
        formData.append("reportName", uniqueReportName);
        formData.append("fromDate", new Date().toISOString());
        formData.append("toDate", new Date().toISOString());
        formData.append("file", new File([file], uniqueReportName, { type: file.type }));
        const apiUrl = "/reports/save";
        dispatch(postFormData({ apiUrl, formData })).unwrap()
            .then((res) => {
                if (res?.success) {
                    swal("Success!", "Report Added Successfully!", "success");
                    parseCSV(res.data.file);
                } else {
                    swal("Upload Failed", "Please upload a valid CSV file.", "error");
                }
            })
            .catch((error) => {
                console.log("Upload Error:", error);
                swal("Error!", "Error uploading CSV.", "error");
            })
            .finally(() => {
                handleFreezStop();
                event.target.value = null;
            });
    };
    const parseCSV = (base64) => {
        try {
            const decoded = atob(base64).trim();
            const lines = decoded.split(/\r?\n/).filter(line => line.trim() !== '');
            if (lines.length < 2) {
                swal("Error", "CSV file has insufficient data.", "error");
                return;
            }
            const headers = lines[0].split(",").map(h => h.trim());
            const rows = lines.slice(1).map((line, index) => {
                const values = line.split(",");
                const row = { id: index };
                headers.forEach((h, i) => (row[h] = values[i]?.trim()));
                return row;
            });
            console.log("Parsed rows:", rows);
            const columns = headers.map(h => ({
                field: h,
                headerName: h,
                flex: 1,
                minWidth: 120,
            }));
            console.log("Columns:", columns);
            setCsvColumns(columns);
            setCsvData(rows);
            setCsvDialogOpen(true);
        } catch (error) {
            console.log("Failed to parse base64 CSV:", error);
            swal("Error", "CSV file could not be parsed correctly.", "error");
        }
    };

    const reportcolumns = [
        {
            field: "reportName", headerName: "List Name", flex: 1, minWidth: 150,
            renderCell: (params) => {
                const value = params.value;
                return value && value.trim() !== "" ? value : "N/A";
            }
        },
        {
            field: "dateRange",
            headerName: "Date Range",
            flex: 1,
            minWidth: 150,
            renderCell: ({ value }) => {
                if (!value || value.trim() === "" || value.trim() === "to") return "N/A";
                const [start, end] = value.split(" to ").map(s => new Date(s.trim()));
                return (!isNaN(start) && !isNaN(end))
                    ? `${start.toLocaleDateString()} to ${end.toLocaleDateString()}`
                    : "N/A";
            },
        }
        ,
        { field: "threshold", headerName: "Threshold", flex: 1, minWidth: 150 },
        {
            field: "softwareUsed", headerName: "Software Used", flex: 1, minWidth: 150,
            renderCell: (params) => params.value && params.value.trim() !== "" ? params.value : "N/A"
        },
        {
            field: "milesRange", headerName: "Miles Range", flex: 1, minWidth: 150,
            renderCell: (params) => params.value && params.value.trim() !== "" ? params.value : "N/A"
        },
        {
            field: "Action",
            headerName: "Action",
            flex: 1,
            minWidth: 150,
            sortable: false,
            renderCell: ({ row }) => (
                <Box display="flex" alignItems="center" gap={2}>
                    <Tooltip title="Create Email">
                        <IconButton size="small" onClick={() => navigate("/email-editor", { state: { selectedReport: row } })} >
                            <EmailIcon color="primary" />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="View Recipients">
                        <IconButton size="small" onClick={() => handleViewRecipients(row)}>
                            <Visibility color="action" />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Delete Report">
                        <IconButton size="small" onClick={() => handleDeleteReport(row)}>
                            <Delete color="action" />
                        </IconButton>
                    </Tooltip>
                </Box>
            ),
        },
    ];
    const [viewCols, setViewCols] = useState([]);
    const [viewRows, setViewRows] = useState([]);
    const [isViewRecipientsOpen, setIsViewRecipientsOpen] = useState(false);
    const [openConfirm, setOpenConfirm] = useState(false);
    const [confirmMessage, setConfirmMessage] = useState("");
    const [confirmAction, setConfirmAction] = useState(() => () => { });
    const handleViewRecipients = (report) => {
        if (!report?.file) {
            swal("Error!", "No file data found in the report.", "error");
            return;
        }
        try {
            const lines = atob(report.file).trim().split("\n");
            const headers = lines[0].split(",").map(h => h.trim());
            const rows = lines.slice(1).map((line, index) => {
                const values = line.split(",");
                const row = { id: index };
                headers.forEach((h, i) => (row[h] = values[i]?.trim()));
                return row;
            });
            setViewCols(headers.map(h => ({
                field: h, headerName: h, flex: 1, minWidth: 200, renderCell: (params) => (
                    <Box sx={{ wordBreak: "break-word", whiteSpace: "normal", overflow: "hidden" }}>
                        {params.value || "N/A"}
                    </Box>
                )
            })));
            setViewRows(rows);
            setIsViewRecipientsOpen(true);
        } catch (error) {
            console.log("Error decoding and parsing file:", error);
            swal("Error!", "Failed to decode recipient data.", "error");
        }
    };
    const handleDeleteReport = (row) => {
        setConfirmMessage(`Are you sure you want to delete the report "${row.reportName || "this report"}"?`);
        setConfirmAction(() => async () => {
            const token = localStorage.getItem("token");
            if (!token) {
                navigate('/login');
                return;
            }
            const formData = new FormData();
            formData.append("reportId", row.id);
            try {
                const res = await dispatch(postFormData({ apiUrl: "/reports/delete", formData })).unwrap();
                if (res?.success) {
                    swal("Deleted!", "Report deleted successfully!", "success");
                    setSavedReports(prev => prev.filter(item => item.id !== row.id));
                } else {
                    swal("Error!", res?.message?.message || res?.message || "Failed to delete the report.", "error");
                }
            } catch (err) {
                swal("Error!", err?.message || err?.error?.message || "An error occurred.", "error");
            }
        });
        setOpenConfirm(true);
    };
   const fetchSavedReports = async () => {
        let token = localStorage.getItem("token");
        if (!token) {
            navigate('/login');
            return;
        }
        handleFreezStart();
        const apiUrl = "/reports/all";
        try {
            const res = await dispatch(fetchData(apiUrl)).unwrap();
            console.log(res);
            if (res?.success) {
                const filteredData = res.data.filter(item => {
                    const noReportName = !item.report_name;
                    const allEmpty = !item.threshold && !item.software_used && !item.miles_range;
                    return !(noReportName && allEmpty);
                });
                const formattedRows = filteredData.map((item) => ({
                    id: item.id,
                    reportName: item.report_name || "Unnamed Report",
                    dateRange: item.date_range
                        ? item.date_range
                            .split(" to ")
                            .map(date => new Date(date.replace(/-/g, "/")).toLocaleDateString())
                            .join(" to ")
                        : "N/A",
                    threshold: item.threshold || "N/A",
                    softwareUsed: item.software_used || "N/A",
                    milesRange: item.miles_range || "N/A",
                    fileName: item.file_name,
                    file: item.file,
                }));
                setSavedReports(formattedRows);
                setShowSavedReportsTable(true);
            } else {
                swal("Error!", "Something went wrong!", "error");
            }
        } catch (error) {
            console.log("Error fetching saved reports:", error);
            swal("Error!", "Failed to fetch saved reports", "error");
        } finally {
            handleFreezStop();
        }
    };
    const [refreshKey, setRefreshKey] = useState(0); // NEW: to trigger reload
    useEffect(() => {
        if (activeTab === 1) {
            fetchSavedReports();
        }
    }, [activeTab, refreshKey]);

    const ContentLayout =
        <>
            <Box sx={{ padding: 1, margin: "auto" }}>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="h5" fontWeight="bold">
                        Recipient List
                    </Typography>
                    <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                        <input
                            type="file"
                            hidden
                            accept=".csv"
                            id="upload-csv"
                            onChange={handleCSVUpload}
                        />
                        <label htmlFor="upload-csv">
                            <Button variant="contained" className="commonBtn" sx={{ mr: 1 }} component="span">
                                Upload CSV
                            </Button>
                        </label>
                        <Button variant="outlined" className="commonOutlinedBtn" onClick={handleDownloadSampleCSV}>Sample CSV</Button>
                    </Box>
                </Box>
                {/* tabs for the Recipient list */}
                <Tabs value={activeTab} onChange={handleTabChange} TabIndicatorProps={{ style: { backgroundColor: "#2A9005" } }}>
                    <Tab label="Create Recipient List" sx={{ textTransform: "none", fontWeight: "bold", color: activeTab === 0 ? "#2A9005" : "inherit", "&.Mui-selected": { color: "#2A9005" } }} />
                    <Tab label="Saved Recipient List" sx={{ textTransform: "none", fontWeight: "bold", color: activeTab === 1 ? "#2A9005" : "inherit", "&.Mui-selected": { color: "#2A9005" } }} />
                </Tabs>
            </Box>
            {activeTab === 0 && (
                <Box>
                    <Grid container spacing={2} alignItems="center" sx={{ mt: 2 }}>
                        <Grid item xs={12} sm={3}>
                            <Typography sx={{ fontSize: 14, color: "#2E67BC" }}>
                                Select Date Range
                            </Typography>
                            {/* <TextField fullWidth size="small" value="01/02/2024 to 02/02/2025" /> */}
                            <FormControl fullWidth size='small'>
                                <Select
                                    labelId="demo-multiple-name-label"
                                    id="demo-multiple-name"
                                    value="date"
                                // input={<OutlinedInput label="Select Date Range" />}
                                >
                                    <MenuItem value="date" >{startDate ? <>{startDate} To {endDate}</> : ''}</MenuItem>
                                    <DateRangePicker
                                        className='custom-date-picker'
                                        onChange={item => setSelectionRange([item.selection])}
                                        showSelectionPreview={true}
                                        moveRangeOnFirstSelection={false}
                                        months={2}
                                        ranges={selectionRange}
                                        maxDate={new Date()}
                                        direction="horizontal"
                                    />
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <Typography sx={{ fontSize: 14, color: "#2E67BC" }}>
                                Category
                            </Typography>
                            <Select
                                fullWidth
                                size="small"
                                value={selectedCategory}
                                onChange={(e) => {
                                    setSelectedCategory(e.target.value);
                                    setSelectedSubCategory(""); // Reset subcategory
                                }}
                            >
                                <MenuItem value="Enrollments">Enrollments</MenuItem>
                                <MenuItem value="Commission">Commission</MenuItem>
                                <MenuItem value="Referrals">Referrals</MenuItem>
                                <MenuItem value="zipCode">zip code</MenuItem>
                                <MenuItem value="SoftwareReferral">Software Referral</MenuItem>
                            </Select>
                        </Grid>
                        {categoryButtons[selectedCategory] && (
                            <Grid item xs={12} sm={2}>
                                <Typography sx={{ fontSize: 14, color: "#2E67BC" }}>
                                    Subcategory
                                </Typography>
                                <Select
                                    fullWidth
                                    size="small"
                                    value={selectedSubCategory}
                                    onChange={(e) => setSelectedSubCategory(e.target.value)}
                                >
                                    {categoryButtons[selectedCategory].map((item, index) => (
                                        <MenuItem key={index} value={item}>
                                            {selectedCategory === "zipCode" ? `${item} (in miles)` : item}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </Grid>
                        )}
                        {selectedSubCategory !== "Top 50" && selectedSubCategory !== "Top 100" && selectedCategory !== "zipCode" && (
                            <Grid item xs={12} sm={2}>
                                <Typography sx={{ fontSize: 14, color: "#2E67BC" }}>
                                    Range
                                </Typography>
                                <Grid container spacing={1}>
                                    <Grid item xs={6}>
                                        <TextField
                                            fullWidth
                                            size="small"
                                            type="number"
                                            value={minThreshold ?? ""}
                                            onChange={handleMinChange}
                                            label="Min"
                                            error={thresholdError} // Show error if validation fails
                                            helperText={thresholdError ? "Min cannot be greater than Max" : ""}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            fullWidth
                                            size="small"
                                            type="number"
                                            value={maxThreshold ?? ""}
                                            onChange={handleMaxChange}
                                            label="Max"
                                            error={thresholdError} // Show error if validation fails
                                            helperText={thresholdError ? "Max cannot be less than Min" : ""}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>

                        )}
                        {selectedCategory === "zipCode" && (
                            <Grid item xs={12} sm={2}>
                                <Typography sx={{ fontSize: 14, color: "#2E67BC" }}>Enter Zip Code</Typography>
                                <TextField
                                    fullWidth
                                    size="small"
                                    type="text"
                                    value={zipCode}
                                    onChange={(e) => {
                                        const input = e.target.value;
                                        // Allow numeric input with a max length of 5
                                        if (/^\d{0,5}$/.test(input)) {
                                            setZipCode(input);
                                        }
                                    }}
                                    error={zipCode.length > 0 && zipCode.length !== 5}
                                    helperText={zipCode.length > 0 && zipCode.length !== 5 ? "Zip code must be 5 digits" : ""}
                                />
                            </Grid>
                        )}
                        <Grid item xs={12} sm={3}>
                            <Box sx={{ mt: 2 }}>
                                <Button variant="contained" className="commonBtn" sx={{ width: 150 }} onClick={handleFetchCommonFilterData}>
                                    Submit
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                    <Box sx={{ mt: 2, mb: 2 }}>
                        <Button variant="contained" className="commonOutlinedBtn" onClick={handleDownloadCSV} disabled={rows.length === 0}>
                            CSV
                        </Button>
                    </Box>
                    {showTable && (
                        <Box sx={{ width: "100%", overflowX: "auto", maxWidth: "100vw" }}>
                            {/* <Box sx={{ width: "100%", maxWidth: "1200px" }}> */}
                            <Box sx={{ width: "100%" }}>
                                <DataGrid
                                    rows={rows}
                                    columns={dataGridColumns.map(col => ({ ...col, flex: 1 }))}
                                    pageSizeOptions={[10, 20, 50]}
                                    pagination
                                    paginationMode="client"
                                    checkboxSelection
                                    autoHeight
                                    initialState={{
                                        pagination: {
                                            paginationModel: { pageSize: 10, page: 0 },
                                        },
                                    }}
                                    slots={{ toolbar: GridToolbar }}
                                    slotProps={{ toolbar: { showQuickFilter: true } }}
                                    sx={{
                                        maxWidth: "100%", // to Prevents the DataGrid overflow
                                        "& .MuiDataGrid-columnHeaders": {
                                            backgroundColor: "#2E67BC",
                                            color: "#fff",
                                            fontWeight: "bold"
                                        }
                                    }}
                                    onRowSelectionModelChange={(selectedIds) => {
                                        const selectedData = rows.filter(row => selectedIds.includes(row.id));
                                        setSelectedRows(selectedData);
                                    }}
                                />
                            </Box>
                        </Box>
                    )}
                    {selectedRows.length === 0 && !uploadedFile && (
                        <Typography variant="body2" color="error" sx={{ mt: 2 }}>
                            {/* Please select recipient or upload a CSV file to create an email. */}
                            Please upload a CSV file to create an email.
                        </Typography>
                    )}
                    <Box sx={{ mt: 1, display: "flex", gap: 2 }}>
                        <Button variant="contained" className="commonBtn" sx={{ width: 150 }} onClick={() => navigate("/email-editor", { state: { selectedRows, uploadedFile } })}
                            disabled={selectedRows.length === 0}
                        >
                            CREATE EMAIL
                        </Button>
                        <Button variant="contained" className="commonBtn" sx={{ width: 150 }} onClick={handleOpen}
                            disabled={selectedRows.length === 0}
                        >
                            SAVE MAILING LIST
                        </Button>
                    </Box>
                </Box>)}
            {activeTab === 1 && (
                <Box>
                    {showSavedReportsTable && (
                        <Box sx={{ width: "100%", overflowX: "auto", maxWidth: "100vw", mt: 3 }}>
                            <DataGrid
                                rows={savedReports}
                                columns={reportcolumns}
                                pageSizeOptions={[10, 20, 50]}
                                pagination
                                paginationMode="client"
                                autoHeight
                                initialState={{
                                    pagination: {
                                        paginationModel: { pageSize: 10, page: 0 },
                                    },
                                }}
                                disableRowSelectionOnClick
                                slots={{ toolbar: GridToolbar }}
                                slotProps={{ toolbar: { showQuickFilter: true } }}
                                sx={{
                                    maxWidth: "100%",
                                    "& .MuiDataGrid-columnHeaders": {
                                        backgroundColor: "#2E67BC",
                                        color: "#fff",
                                        fontWeight: "bold"
                                    }
                                }}
                                onRowSelectionModelChange={(selectedIds) => {
                                    const selectedData = savedReports.filter(row => selectedIds.includes(row.id));
                                    setSelectedRows(selectedData);
                                }}
                            />
                        </Box>
                    )}
                </Box>
            )}
            <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
                <DialogTitle>Save Report</DialogTitle>
                <IconButton
                    edge="end"
                    color="inherit"
                    onClick={() => setOpen(false)}
                    aria-label="close"
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent>
                    <TextField
                        fullWidth
                        size="small"
                        label="Report Name"
                        placeholder="Enter name to save the report"
                        variant="outlined"
                        value={reportName}
                        onChange={(e) => setReportName(e.target.value)}
                        sx={{ mt: 1 }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleSaveReport} variant="contained" className="send-button">
                        Save
                    </Button>
                    <Button onClick={() => setOpen(false)} variant="outlined" className="commonOutlinedBtn" >
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
             <Dialog open={csvDialogOpen} onClose={(event, reason) => { if (reason !== 'backdropClick') { setCsvDialogOpen(false); } }} maxWidth="md" fullWidth>
                <DialogTitle>Uploaded CSV Data</DialogTitle>
                <IconButton
                    edge="end"
                    color="inherit"
                    onClick={() => setCsvDialogOpen(false)}
                    aria-label="close"
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent>
                    <Box sx={{ width: "100%", mx: "auto" }}>
                        <DataGrid
                            rows={csvData}
                            columns={csvColumns}
                            initialState={{
                                pagination: {
                                    paginationModel: { pageSize: 5, page: 0 }
                                }
                            }}
                            pageSizeOptions={[5, 10, 20]}
                            pagination
                            sx={{
                                height: 400,
                                maxWidth: "100%",
                                "& .MuiDataGrid-columnHeaders": {
                                    backgroundColor: "#2E67BC",
                                    color: "#fff",
                                    fontWeight: "bold"
                                }
                            }}
                        />
                    </Box>
                    <Box sx={{ mt: 1, display: "flex", gap: 2 }}>
                        <Button
                            variant="contained"
                            className="commonBtn"
                            sx={{ width: 150 }}
                            onClick={() => { navigate("/email-editor", { state: { selectedRows, uploadedFile } }); }}
                        >
                            CREATE EMAIL
                        </Button>
                        <Button
                            variant="contained"
                            className="commonBtn"
                            sx={{ width: 150 }}
                            onClick={() => { handleTabChange(null, 1); setRefreshKey(prev => prev + 1); setCsvDialogOpen(false); swal("Mailing list saved successfully!"); }}
                            disabled={!(selectedRows.length > 0 || uploadedFile)}
                        >
                            SAVE
                        </Button>
                    </Box>
                </DialogContent>
            </Dialog>
            <Dialog open={isViewRecipientsOpen} onClose={() => setIsViewRecipientsOpen(false)} maxWidth="md" fullWidth>
                <DialogTitle>
                    Recipient List
                    <IconButton
                        edge="end"
                        color="inherit"
                        onClick={() => setIsViewRecipientsOpen(false)}
                        aria-label="close"
                        sx={{ position: 'absolute', right: 8, top: 8 }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Box style={{ height: 400, width: "100%" }}>
                        <DataGrid rows={viewRows} columns={viewCols} pageSize={10} sx={{
                            "& .MuiDataGrid-columnHeaders": {
                                backgroundColor: "#2E67BC",
                                color: "#fff",
                                fontWeight: "bold"
                            }
                        }} />
                    </Box>
                </DialogContent>
            </Dialog>
            <Dialog open={openConfirm} onClose={() => setOpenConfirm(false)} maxWidth="xs" fullWidth>
                <DialogTitle>Confirmation</DialogTitle>
                <DialogContent>{confirmMessage}</DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenConfirm(false)} color="primary">Cancel</Button>
                    <Button onClick={() => { confirmAction(); setOpenConfirm(false); }} color="error" variant="contained">
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>

        </>
    return (
        <>
            <DefaultLayout content={ContentLayout} />
            <div>
                <Backdrop
                    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.modal + 1 }}
                    open={freez}
                    onClick={handleFreezStop}
                >
                    <Freez />
                </Backdrop>
            </div>
        </>
    );
};
export default RecipientList;